var L = Object.defineProperty;
var V = (t, e, r) => e in t ? L(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var y = (t, e, r) => (V(t, typeof e != "symbol" ? e + "" : e, r), r);
var I = { exports: {} }, P = Object.defineProperty, F = Object.getOwnPropertyDescriptor, W = Object.getOwnPropertyNames, X = Object.prototype.hasOwnProperty, Z = (t, e) => {
  for (var r in e)
    P(t, r, { get: e[r], enumerable: !0 });
}, z = (t, e, r, o) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let n of W(e))
      !X.call(t, n) && n !== r && P(t, n, { get: () => e[n], enumerable: !(o = F(e, n)) || o.enumerable });
  return t;
}, ee = (t) => z(P({}, "__esModule", { value: !0 }), t), R = {};
Z(R, {
  findExistingMetric: () => ne,
  formatCounterOrGauge: () => oe,
  formatHistogramOrSummary: () => re
});
var T = ee(R);
function te(t) {
  const e = Object.entries(t.labels || {}).map(
    ([r, o]) => `${r}="${o}"`
  );
  return e.length === 0 ? "" : `${e.join(",")}`;
}
function re(t, e, r = "le") {
  let o = "";
  const n = te(e);
  return n.length > 0 ? (o += `${t}_count{${n}} ${e.value.count}
`, o += `${t}_sum{${n}} ${e.value.sum}
`) : (o += `${t}_count ${e.value.count}
`, o += `${t}_sum ${e.value.sum}
`), Object.entries(e.value.entries).reduce(
    (s, [i, a]) => n.length > 0 ? `${s}${t}_bucket{${r}="${i}",${n}} ${a}
` : `${s}${t}_bucket{${r}="${i}"} ${a}
`,
    o
  );
}
function ne(t, e = []) {
  return t ? e.find((r) => {
    if (!r.labels || Object.keys(r.labels || {}).length !== Object.keys(t).length)
      return !1;
    const o = Object.entries(t);
    for (let n = 0; n < o.length; n += 1) {
      const [s, i] = o[n];
      if (r.labels[s] !== i)
        return !1;
    }
    return !0;
  }) : e[0];
}
function oe(t, e) {
  const r = ` ${e.value.toString()}`;
  if (e.labels == null || Object.keys(e.labels).length === 0)
    return `${t}${r}
`;
  const o = Object.entries(e.labels).map(([n, s]) => `${n}="${s}"`);
  return `${t}{${o.join(",")}}${r}
`;
}
var j = Object.defineProperty, se = Object.getOwnPropertyDescriptor, ie = Object.getOwnPropertyNames, ae = Object.prototype.hasOwnProperty, ue = (t, e) => {
  for (var r in e)
    j(t, r, { get: e[r], enumerable: !0 });
}, ce = (t, e, r, o) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let n of ie(e))
      !ae.call(t, n) && n !== r && j(t, n, { get: () => e[n], enumerable: !(o = se(e, n)) || o.enumerable });
  return t;
}, _e = (t) => ce(j({}, "__esModule", { value: !0 }), t), G = {};
ue(G, {
  Collector: () => le
});
var U = _e(G), k = T;
class le {
  constructor() {
    y(this, "data");
    this.data = [];
  }
  get(e) {
    return (0, k.findExistingMetric)(e, this.data);
  }
  set(e, r) {
    const o = (0, k.findExistingMetric)(r, this.data);
    return o ? o.value = e : this.data.push({
      labels: r,
      value: e
    }), this;
  }
  collect(e) {
    return e ? this.data.filter((r) => {
      if (!r.labels)
        return !1;
      const o = Object.entries(e);
      for (let n = 0; n < o.length; n += 1) {
        const [s, i] = o[n];
        if (r.labels[s] !== i)
          return !1;
      }
      return !0;
    }) : this.data;
  }
  resetAll() {
    for (let e = 0; e < this.data.length; e += 1)
      this.reset(this.data[e].labels);
    return this;
  }
}
var m = Object.defineProperty, ge = Object.getOwnPropertyDescriptor, pe = Object.getOwnPropertyNames, ve = Object.prototype.hasOwnProperty, fe = (t, e) => {
  for (var r in e)
    m(t, r, { get: e[r], enumerable: !0 });
}, he = (t, e, r, o) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let n of pe(e))
      !ve.call(t, n) && n !== r && m(t, n, { get: () => e[n], enumerable: !(o = ge(e, n)) || o.enumerable });
  return t;
}, $e = (t) => he(m({}, "__esModule", { value: !0 }), t), A = {};
fe(A, {
  Counter: () => Oe
});
var J = $e(A), ye = U;
class Oe extends ye.Collector {
  inc(e) {
    return this.add(1, e), this;
  }
  add(e, r) {
    if (e < 0)
      throw new Error(
        `Expected increment amount to be greater than -1. Received: ${e}`
      );
    const o = this.get(r);
    return this.set(o ? o.value + e : e, r), this;
  }
  reset(e) {
    this.set(0, e);
  }
}
var x = Object.defineProperty, de = Object.getOwnPropertyDescriptor, be = Object.getOwnPropertyNames, we = Object.prototype.hasOwnProperty, Pe = (t, e) => {
  for (var r in e)
    x(t, r, { get: e[r], enumerable: !0 });
}, je = (t, e, r, o) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let n of be(e))
      !we.call(t, n) && n !== r && x(t, n, { get: () => e[n], enumerable: !(o = de(e, n)) || o.enumerable });
  return t;
}, me = (t) => je(x({}, "__esModule", { value: !0 }), t), q = {};
Pe(q, {
  Gauge: () => Se
});
var xe = me(q), Ce = J;
class Se extends Ce.Counter {
  dec(e) {
    const r = this.get(e);
    return this.set(r ? r.value - 1 : 0, e), this;
  }
  sub(e, r) {
    const o = this.get(r);
    return this.set(o ? o.value - e : 0, r), this;
  }
}
var C = Object.defineProperty, Me = Object.getOwnPropertyDescriptor, ke = Object.getOwnPropertyNames, Ee = Object.prototype.hasOwnProperty, De = (t, e) => {
  for (var r in e)
    C(t, r, { get: e[r], enumerable: !0 });
}, He = (t, e, r, o) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let n of ke(e))
      !Ee.call(t, n) && n !== r && C(t, n, { get: () => e[n], enumerable: !(o = Me(e, n)) || o.enumerable });
  return t;
}, Ie = (t) => He(C({}, "__esModule", { value: !0 }), t), B = {};
De(B, {
  Histogram: () => Ue
});
var Re = Ie(B), Te = U;
function Ge(t, e) {
  if (e < t[t.length - 1]) {
    for (let r = 0; r < t.length; r += 1)
      if (e <= t[r])
        return r;
  }
}
function b(t) {
  return {
    entries: t.reduce(
      (r, o) => (r[o.toString()] = 0, r),
      { "+Inf": 0 }
    ),
    sum: 0,
    count: 0,
    raw: []
  };
}
class Ue extends Te.Collector {
  constructor(r = []) {
    super();
    y(this, "buckets");
    this.buckets = r.sort((o, n) => o > n ? 1 : -1), this.set(b(this.buckets)), this.observe = this.observe.bind(this);
  }
  observe(r, o) {
    let n = this.get(o);
    n == null && (n = this.set(b(this.buckets), o).get(o)), n.value.raw.push(r), n.value.entries["+Inf"] += 1;
    const s = Ge(this.buckets, r);
    if (s != null)
      for (let i = s; i < this.buckets.length; i += 1) {
        const a = n.value.entries[this.buckets[i].toString()];
        n.value.entries[this.buckets[i].toString()] = a + 1;
      }
    return n.value.sum = n.value.raw.reduce((i, a) => i + a, 0), n.value.count += 1, this;
  }
  reset(r) {
    this.set(b(this.buckets), r);
  }
}
var S = Object.defineProperty, Ae = Object.getOwnPropertyDescriptor, Je = Object.getOwnPropertyNames, qe = Object.prototype.hasOwnProperty, Be = (t, e) => {
  for (var r in e)
    S(t, r, { get: e[r], enumerable: !0 });
}, Ke = (t, e, r, o) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let n of Je(e))
      !qe.call(t, n) && n !== r && S(t, n, { get: () => e[n], enumerable: !(o = Ae(e, n)) || o.enumerable });
  return t;
}, Ne = (t) => Ke(S({}, "__esModule", { value: !0 }), t), K = {};
Be(K, {
  Registry: () => Fe
});
var Qe = Ne(K), Ye = J, Le = xe, Ve = Re, E = T;
class Fe {
  constructor() {
    y(this, "data");
    this.data = {
      counter: {},
      gauge: {},
      histogram: {}
    };
  }
  validateInput(e, r, o, n) {
    if (String(r) === "")
      throw new Error("Metric name cannot be empty");
    if (["counter", "gauge", "histogram"].indexOf(e) === -1)
      throw new Error(`Unknown metric type ${e}`);
    if (typeof o != "string" && o != null)
      throw new Error("help must be string or undefined/null");
    if (this.data[e][r])
      throw new Error(
        `A metric with the name '${r}' already exists for type '${e}'`
      );
    if (!Array.isArray(n) && n != null)
      throw new Error("buckets must be array or undefined/null");
  }
  create(e, r, o = "", n = []) {
    this.validateInput(e, r, o, n);
    let s;
    return e === "counter" ? (s = new Ye.Counter(), this.data.counter[r] = { help: o, instance: s, type: e }) : e === "gauge" ? (s = new Le.Gauge(), this.data.gauge[r] = { help: o, instance: s, type: e }) : (s = new Ve.Histogram(n), this.data.histogram[r] = { help: o, instance: s, type: e }), s;
  }
  /**
   * Returns a string in the prometheus' desired format
   * More info: https://prometheus.io/docs/concepts/data_model/
   * Loop through each metric type (counter, histogram, etc);
   *
   * @return {string}
   */
  metrics() {
    return Object.entries(this.data).reduce(
      (e, [r, o]) => e + Object.entries(o).reduce((n, [s, i]) => {
        const a = i.instance.collect();
        let _ = n;
        return i.help.length > 0 && (_ += `# HELP ${s} ${i.help}
`), _ += `# TYPE ${s} ${r}
`, _ += a.reduce((l, g) => {
          const f = r === "histogram" ? (0, E.formatHistogramOrSummary)(
            s,
            g
          ) : (0, E.formatCounterOrGauge)(s, g);
          return l + f;
        }, ""), _;
      }, ""),
      ""
    );
  }
  reset() {
    return Object.values(this.data).map(
      (e) => Object.values(e).map(({ instance: r }) => r.resetAll())
    ), this;
  }
  clear() {
    return this.data = {
      counter: {},
      gauge: {},
      histogram: {}
    }, this;
  }
  get(e, r) {
    const n = (e != null ? [this.data[e]] : Object.values(this.data)).find((s) => r in s);
    return n != null ? n[r].instance : void 0;
  }
}
var N = Object.defineProperty, We = Object.getOwnPropertyDescriptor, Xe = Object.getOwnPropertyNames, Ze = Object.prototype.hasOwnProperty, ze = (t, e, r, o) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let n of Xe(e))
      !Ze.call(t, n) && n !== r && N(t, n, { get: () => e[n], enumerable: !(o = We(e, n)) || o.enumerable });
  return t;
}, et = (t) => ze(N({}, "__esModule", { value: !0 }), t), tt = {}, rt = et(tt);
(function(t) {
  var e = Object.defineProperty, r = Object.getOwnPropertyDescriptor, o = Object.getOwnPropertyNames, n = Object.prototype.hasOwnProperty, s = (c, u) => {
    for (var p in u)
      e(c, p, { get: u[p], enumerable: !0 });
  }, i = (c, u, p, M) => {
    if (u && typeof u == "object" || typeof u == "function")
      for (let h of o(u))
        !n.call(c, h) && h !== p && e(c, h, { get: () => u[h], enumerable: !(M = r(u, h)) || M.enumerable });
    return c;
  }, a = (c, u, p) => (i(c, u, "default"), p && i(p, u, "default")), _ = (c) => i(e({}, "__esModule", { value: !0 }), c), l = {};
  s(l, {
    Registry: () => g.Registry,
    default: () => f
  }), t.exports = _(l);
  var g = Qe;
  a(l, rt, t.exports);
  var f = () => new g.Registry();
})(I);
var nt = I.exports;
function ct() {
  return d().metrics();
}
function d() {
  return Q(), w().registry;
}
function w() {
  return globalThis;
}
function Q() {
  w().registry || (w().registry = new nt.Registry());
}
function _t(t, {
  timeHistogramBuckets: e = st,
  quantityHistogramBuckets: r = it
} = {}) {
  return Q(), {
    getCounter: (o) => ({
      inc: (n, s) => {
        const i = `${t}_${o}_total`;
        ot(i).add(s ?? 1, n);
      }
    }),
    getGauge: (o) => ({
      set: (n, s) => {
        const i = `${t}_${o}_total`;
        Y(i).set(s, n);
      }
    }),
    getHistogram: (o, n) => O(
      `${t}_${o}_execution_time_seconds`,
      n ?? e
    ),
    getQuantityHistogram: (o) => O(`${t}_${o}_quantity`, r),
    getDurationSecondsHistogram: (o) => O(
      `${t}_${o}_duration_seconds`,
      e
    ),
    getExecutionTimeSecondsHistogram: (o) => O(
      `${t}_${o}_execution_time_seconds`,
      e
    ),
    collectNodeMetrics: () => at(t)
  };
}
function O(t, e) {
  return {
    observe: (r, o) => {
      D(t, e).observe(o, {
        ...r
      });
    },
    startTimer: () => {
      const r = D(t, e), o = performance.now();
      return (n) => {
        const s = (performance.now() - o) / 1e3;
        r.observe(s, n);
      };
    }
  };
}
function ot(t) {
  const e = d();
  return e.get("counter", t) ?? e.create("counter", t, "");
}
function Y(t) {
  const e = d();
  return e.get("gauge", t) ?? e.create("gauge", t, "");
}
function D(t, e) {
  const r = d();
  return r.get("histogram", t) ?? r.create("histogram", t, "", e);
}
const st = [0.1, 0.2, 0.5, 1, 2, 4, 8, 10, 16, 32, 48, 64], it = [
  1,
  2,
  4,
  8,
  10,
  16,
  20,
  32,
  40,
  50,
  64,
  128,
  256,
  512
];
function at(t) {
  var i, a;
  const e = process.hrtime.bigint();
  setImmediate(() => {
    const _ = process.hrtime.bigint(), l = Number(_ - e) / 1e9;
    v(`${t}_nodejs_eventloop_lag_seconds`, l);
  });
  const r = process.memoryUsage();
  $(`${t}_arrayBuffers`, r.arrayBuffers), $(`${t}_external`, r.external), $(`${t}_heapTotal`, r.heapTotal), $(`${t}_heapUsed`, r.heapUsed), $(`${t}_rss`, r.rss);
  const o = process.cpuUsage();
  H(`${t}_user`, o.user), H(`${t}_system`, o.system);
  const n = (i = process == null ? void 0 : process._getActiveHandles()) == null ? void 0 : i.length;
  v(`${t}_nodejs_active_handles`, n);
  const s = (a = process == null ? void 0 : process._getActiveRequests()) == null ? void 0 : a.length;
  v(`${t}_nodejs_active_requests`, s), v(`${t}_nodejs_version_info`, 1, {
    version: process.version
  }), v(`${t}_nodejs_process_uptime_seconds`, process.uptime());
}
function H(t, e) {
  v(t, e / 1e6, {
    mode: t.split("_").pop() || ""
  });
}
function $(t, e) {
  v(t, e, {
    type: t.split("_").pop() || ""
  });
}
function v(t, e, r = {}) {
  Y(`${t}_total`).set(e, r);
}
function lt({
  metrics: t,
  inner: e,
  prefix: r = "",
  labels: o = {}
}) {
  return new Proxy(e, {
    get(n, s, i) {
      if (typeof n[s] == "function") {
        const a = r ? `${r}_${String(s)}` : String(s), _ = t.getHistogram(a), l = t.getCounter(`${a}_failed`);
        return function(...g) {
          const f = _.startTimer();
          try {
            const c = n[s].apply(this, g);
            return c.then ? c.then((u) => (f(o), u)).catch((u) => {
              throw l.inc(o), u;
            }) : (f(o), c);
          } catch (c) {
            throw l.inc(o), c;
          }
        };
      }
      return Reflect.get(n, s, i);
    },
    set(n, s, i, a) {
      return Reflect.set(n, s, i, a);
    }
  });
}
export {
  _t as getMetrics,
  ct as renderMetrics,
  lt as withMetrics
};
